import { useDispatch } from 'react-redux'
import { Route, Switch, Redirect, useLocation, useRouteMatch } from 'react-router-dom'

import { redirectTo } from 'actions/core/navigation'
import { useFetchInvitationRedirectQuery } from 'features/organization_settings'

import {
  withAllPagesAuthorization,
  withAllUsersAuthorization,
  withUserAuthorization,
  withPageAuthorization,
  withUserGroupAuthorization
} from './hoc'
import { MeetingTypes } from './lazy'

const AllPagesMeetingTypes = withAllPagesAuthorization(MeetingTypes)
const AllUsersMeetingTypes = withAllUsersAuthorization(MeetingTypes)
const PageMeetingTypes = withPageAuthorization(MeetingTypes)
const UserMeetingTypes = withUserAuthorization(MeetingTypes)
const GroupMeetingTypes = withUserGroupAuthorization(MeetingTypes)

export const MeetingTypesRoutes = () => {
  const dispatch = useDispatch()
  const { pathname } = useLocation()
  const { path: basePath } = useRouteMatch()

  const { isFetching, data } = useFetchInvitationRedirectQuery()

  if (!isFetching && data?.redirectTo) {
    dispatch(redirectTo(data.redirectTo))
  }

  return (
    <Switch>
      <Route path={basePath}>
        <Switch>
          <Route exact path={`${basePath}/user/me`} component={MeetingTypes} />
          <Route exact path={`${basePath}/team`} component={AllPagesMeetingTypes} />
          <Route exact path={`${basePath}/all_users_and_teams`} component={AllUsersMeetingTypes} />
          <Route exact path={`${basePath}/all_users`} component={AllUsersMeetingTypes} />
          <Route exact path={`${basePath}/team/:team_id`} component={PageMeetingTypes} />
          <Route exact path={`${basePath}/user_group/:user_group_id`} component={GroupMeetingTypes} />
          <Route exact path={`${basePath}/user/:user_id`} component={UserMeetingTypes} />
          <Route component={MeetingTypes} />
        </Switch>
      </Route>
      <Redirect to={pathname} />
    </Switch>
  )
}
